import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Choghadiya.css";

function ChoghadiyaMuhurta() {
  const getCurrentDate = () => {
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const year = now.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const [params, setParams] = useState({
    date: getCurrentDate(),
    time: getCurrentTime(),
    latitude: "24",
    longitude: "76",
    tz: "5.5",
  });

  const [language, setLanguage] = useState("en");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const fetchChoghadiyaMuhurta = () => {
    setLoading(true);
    setError("");
    setResult(null);

    fetch(
      `https://api.jyotishamastroapi.com/api/panchang/choghadiya-muhurta?date=${params.date}&time=${params.time}&latitude=${params.latitude}&longitude=${params.longitude}&tz=${params.tz}&lang=${language}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          key: "2a10JhmcIyTL81Pivmzo92ynCeS04v",
        },
      }
    )
      .then((res) => {
        if (!res.ok) throw new Error(`API Error: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        if (data && data.response) {
          setResult(data.response);
        } else {
          setError("No data found.");
        }
      })
      .catch((err) => setError(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchChoghadiyaMuhurta();
  }, [language]); // 🔁 Auto-fetch when language changes

  return (
    <div className="ra-main-panchang">

      <div
        className="DailyPanchang-top-buttons"
         style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
      >
        {/* Top Buttons */}
                <div
                  className="DailyPanchang-top-buttons"
                  style={{
                    marginBottom: "1rem",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* Calendar Logo SVG */}
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      style={{ marginRight: "0.75rem" }}
                    >
                      <rect
                        x="3"
                        y="5"
                        width="18"
                        height="16"
                        rx="2"
                        stroke="#333"
                        strokeWidth="2"
                        fill="#f5f5f5"
                      />
                      <path
                        d="M16 3v4M8 3v4"
                        stroke="#333"
                        strokeWidth="2"
                        strokeLinecap="round"
                      />
                      <path d="M3 9h18" stroke="#333" strokeWidth="2" />
                    </svg>
        

                     <Link to="/panchang" style={{ textDecoration: "none",marginRight: "10px"  }}>
              <button type="button">📅 Daily Panchang</button>
            </Link>

                    <Link to="/MonthlyPanchang" style={{ textDecoration: "none", marginRight: "10px" }}>
                      <button type="button">📅 Monthly Panchang</button>
                    </Link>
                    
        
                    <Link to="/Hora" style={{ textDecoration: "none", marginRight: "10px" }}>
                      <button type="button">Hora</button>
                    </Link>
                
                    
                  </div>
                </div>
      </div>

      <h2>🕉 Choghadiya Muhurta</h2>

      {/* Input Section */}
      <div className="Choghadiya-panchang-inputs">
        <input
          type="text"
          value={params.date}
          onChange={(e) => setParams({ ...params, date: e.target.value })}
          placeholder="Date (DD/MM/YYYY)"
        />
        <input
          type="text"
          value={params.time}
          onChange={(e) => setParams({ ...params, time: e.target.value })}
          placeholder="Time (HH:MM)"
        />

        {/* 🌐 Multiple Language Selector */}
        <select
          className="panchang-lang"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="en">English</option>
          <option value="hi">Hindi</option>
          <option value="be">Bengali</option>
          <option value="ta">Tamil</option>
          <option value="te">Telugu</option>
          <option value="ka">Kannada</option>
          <option value="ml">Malayalam</option>
          <option value="mr">Marathi</option>
          <option value="gr">Gujarati</option>
        </select>

        <button onClick={fetchChoghadiyaMuhurta} disabled={loading}>
          {loading ? "Loading..." : "Get Muhurta"}
        </button>
      </div>

      {error && <p className="Choghadiya-error-text">❌ {error}</p>}

      {result && (
        <div className="Choghadiya-result">
          <h3>🌞 Day Choghadiya ({result.day_of_week})</h3>
          <div className="Choghadiya-panchang-grid">
            {result.day.map((item, idx) => (
              <div
                key={idx}
                className={`Choghadiya-panchang-card ${
                  item.type === "Auspicious"
                    ? "card-auspicious"
                    : item.type === "Inauspicious"
                    ? "card-inauspicious"
                    : "card-good"
                }`}
              >
                <h4>{item.muhurat}</h4>
                <p>
                  <strong>Start:</strong> {item.start}
                </p>
                <p>
                  <strong>End:</strong> {item.end}
                </p>
                <p>
                  <strong>Type:</strong> {item.type}
                </p>
              </div>
            ))}
          </div>

          <h3>🌙 Night Choghadiya</h3>
          <div className="Choghadiya-panchang-grid">
            {result.night.map((item, idx) => (
              <div
                key={idx}
                className={`Choghadiya-panchang-card ${
                  item.type === "Auspicious"
                    ? "card-auspicious"
                    : item.type === "Inauspicious"
                    ? "card-inauspicious"
                    : "card-good"
                }`}
              >
                <h4>{item.muhurat}</h4>
                <p>
                  <strong>Start:</strong> {item.start}
                </p>
                <p>
                  <strong>End:</strong> {item.end}
                </p>
                <p>
                  <strong>Type:</strong> {item.type}
                </p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default ChoghadiyaMuhurta;
